/** Keep internal agent names out of customer-facing persisted content. */
export function toCustomerCopy(value: string): string {
  return value
    .replace(/([\u3400-\u9fff])\s*Luo\s*(?=[\u3400-\u9fff])/g, '$1我们')
    .replace(/Luo\s*(?=[\u3400-\u9fff])/g, '我们')
    .replace(/Luo/g, '我们');
}
